module.exports = __webpack_public_path__ + "img/i_makeup.47dc4dfb.png";